


// import React, { Component } from "react";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import "./DriverLastLocationMap.css";

// const IRELAND_CENTER = [53.35, -8.0];
// const IRELAND_BOUNDS = [
//   [51.2, -11.1],
//   [55.7, -5.2],
// ];
// const COUNTY_GEOJSON_URL =
//   "https://gist.githubusercontent.com/martinbpeters/34e258dadca967393291b7a128857350/raw/a246b15c25c66532842dad71e3a86276ee44055f/counties.geojson";

// export default class DriverLastLocationMap extends Component {
//   constructor(props) {
//     super(props);

//     this.mapContainer = React.createRef();
//     this.map = null;
//     this.driverLayers = null;
//     this.countyLayer = null;

//     this.state = {
//       countyLoading: true,
//       countyError: false,
//     };
//   }

//   componentDidMount() {
//     this.map = L.map(this.mapContainer.current, {
//       center: IRELAND_CENTER,
//       zoom: 7,
//       minZoom: 6,
//       maxBounds: IRELAND_BOUNDS,
//       maxBoundsViscosity: 0.75,
//       preferCanvas: true,
//     });

//     L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//       maxZoom: 19,
//       attribution:
//         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
//     }).addTo(this.map);

//     this.driverLayers = L.layerGroup().addTo(this.map);
//     this._loadCounties();
//     this._drawDrivers();
//   }

//   componentDidUpdate(previousProps) {
//     if (previousProps.drivers !== this.props.drivers) {
//       this._drawDrivers();
//     }
//   }

//   componentWillUnmount() {
//     if (this.map) {
//       this.map.remove();
//       this.map = null;
//     }
//   }

//   _validDrivers() {
//     return (this.props.drivers || []).filter((driver) => {
//       const latitude = Number(driver.latitude);
//       const longitude = Number(driver.longitude);

//       return (
//         Number.isFinite(latitude) &&
//         Number.isFinite(longitude) &&
//         latitude >= IRELAND_BOUNDS[0][0] &&
//         latitude <= IRELAND_BOUNDS[1][0] &&
//         longitude >= IRELAND_BOUNDS[0][1] &&
//         longitude <= IRELAND_BOUNDS[1][1]
//       );
//     });
//   }

//   _getCountyName(feature) {
//     const properties = feature?.properties || {};

//     return (
//       properties.NAME_EN ||
//       properties.ENGLISH ||
//       properties.ENGLISH_NAME ||
//       properties.COUNTY ||
//       properties.County ||
//       properties.county ||
//       properties.NAME ||
//       properties.name ||
//       properties.NAME_2 ||
//       "County"
//     );
//   }

//   async _loadCounties() {
//     try {
//       const response = await fetch(
//         this.props.countyGeoJsonUrl || COUNTY_GEOJSON_URL
//       );

//       if (!response.ok) {
//         throw new Error("County boundary request failed.");
//       }

//       const countyGeoJson = await response.json();

//       if (!this.map) {
//         return;
//       }

//       this.countyLayer = L.geoJSON(countyGeoJson, {
//         style: {
//           color: "#6c757d",
//           weight: 1.25,
//           opacity: 0.8,
//           fillColor: "#f4f6f9",
//           fillOpacity: 0.08,
//         },
//         onEachFeature: (feature, layer) => {
//           const countyName = this._getCountyName(feature);

//           layer.bindTooltip(countyName, {
//             permanent: true,
//             direction: "center",
//             className: "driver-map-county-label",
//           });
//         },
//       }).addTo(this.map);

//       this.countyLayer.bringToBack();
//       this.setState({ countyLoading: false, countyError: false });
//     } catch (error) {
//       console.error("Unable to load Ireland county boundaries:", error);

//       if (this.map) {
//         this.setState({ countyLoading: false, countyError: true });
//       }
//     }
//   }

//   _formatLastSeen(value) {
//     if (!value) {
//       return "Not provided";
//     }

//     const date = new Date(value);

//     return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
//   }

//   _createPopup(driver) {
//     const container = document.createElement("div");
//     const name = document.createElement("strong");
//     const status = document.createElement("div");
//     const county = document.createElement("div");
//     const location = document.createElement("div");
//     const lastSeen = document.createElement("div");

//     name.textContent = driver.name || "Driver";
//     status.textContent = `Status: ${
//       driver.isActive ? "Able To Accept Deliveries" : "Offline"
//     }`;
//     status.style.color = driver.isActive ? "#198754" : "#dc3545";
//     status.style.fontWeight = "600";
//     county.textContent = `County: ${driver.county || "Not provided"}`;
//     location.textContent = `Last location: ${Number(driver.latitude).toFixed(
//       6
//     )}, ${Number(driver.longitude).toFixed(6)}`;
//     lastSeen.textContent = `Last location update: ${this._formatLastSeen(
//       driver.lastLocationAt
//     )}`;

//     container.appendChild(name);
//     container.appendChild(status);
//     container.appendChild(county);
//     container.appendChild(location);
//     container.appendChild(lastSeen);

//     return container;
//   }

//   _drawDrivers() {
//     if (!this.map || !this.driverLayers) {
//       return;
//     }

//     this.driverLayers.clearLayers();

//     const drivers = this._validDrivers();
//     const bounds = L.latLngBounds([]);

//     drivers.forEach((driver) => {
//       const point = [Number(driver.latitude), Number(driver.longitude)];
//       const colour = driver.isActive ? "#28a745" : "#dc3545";

//       L.circleMarker(point, {
//         radius: 8,
//         color: "#ffffff",
//         weight: 2,
//         fillColor: colour,
//         fillOpacity: 1,
//       })
//         .bindTooltip(driver.name || "Driver", {
//           direction: "top",
//           offset: [0, -9],
//         })
//         .bindPopup(this._createPopup(driver))
//         .addTo(this.driverLayers);

//       bounds.extend(point);
//     });

//     if (bounds.isValid()) {
//       this.map.fitBounds(bounds, {
//         padding: [35, 35],
//         maxZoom: 12,
//       });
//     } else {
//       this.map.setView(IRELAND_CENTER, 7);
//     }
//   }

//   render() {
//     const drivers = this._validDrivers();
//     const activeCount = drivers.filter((driver) => driver.isActive).length;
//     const offlineCount = drivers.length - activeCount;
//     const { countyLoading, countyError } = this.state;

//     return (
//       <div className="card card-custom mb-5">
//         <div className="card-header">
//           <div className="card-title">
//             <h3 className="card-label">
//               Driver Last Known Locations
//               <small className="text-muted ml-2">
//                 {drivers.length} mapped driver{drivers.length === 1 ? "" : "s"}
//               </small>
//             </h3>
//           </div>

//           <div className="card-toolbar driver-map-legend">
//             <span className="mr-4">
//               <span className="driver-map-dot driver-map-dot-active" />
//               Able To Accept Deliveries ({activeCount})
//             </span>
//             <span>
//               <span className="driver-map-dot driver-map-dot-offline" />
//               Offline ({offlineCount})
//             </span>
//           </div>
//         </div>

//         <div className="card-body p-0 position-relative">
//           {this.props.loading && (
//             <div className="driver-map-loading">
//               <span className="spinner-border text-primary mr-2" />
//               Loading driver locations...
//             </div>
//           )}

//           {!this.props.loading && countyLoading && (
//             <div className="driver-map-boundary-status">
//               Loading county boundaries...
//             </div>
//           )}

//           {countyError && (
//             <div className="driver-map-boundary-status text-danger">
//               County boundaries could not be loaded.
//             </div>
//           )}

//           <div
//             ref={this.mapContainer}
//             aria-label="Map of drivers' last known locations in Ireland"
//             style={{ height: 560, width: "100%" }}
//           />
//         </div>
//       </div>
//     );
//   }
// }

// DriverLastLocationMap.defaultProps = {
//   drivers: [],
//   loading: false,
//   countyGeoJsonUrl: COUNTY_GEOJSON_URL,
// };





import React, { Component } from "react";
import L from "leaflet";
import moment from "moment";
import "leaflet/dist/leaflet.css";
import "./DriverLastLocationMap.css";

const IRELAND_CENTER = [53.35, -8.0];
const IRELAND_BOUNDS = [
  [51.2, -11.1],
  [55.7, -5.2],
];
const COUNTY_GEOJSON_URL =
  "https://gist.githubusercontent.com/martinbpeters/34e258dadca967393291b7a128857350/raw/a246b15c25c66532842dad71e3a86276ee44055f/counties.geojson";

export default class DriverLastLocationMap extends Component {
  constructor(props) {
    super(props);

    this.mapContainer = React.createRef();
    this.map = null;
    this.driverLayers = null;
    this.countyLayer = null;

    this.state = {
      countyLoading: true,
      countyError: false,
    };
  }

  componentDidMount() {
    this.map = L.map(this.mapContainer.current, {
      center: IRELAND_CENTER,
      zoom: 7,
      minZoom: 6,
      maxBounds: IRELAND_BOUNDS,
      maxBoundsViscosity: 0.75,
      preferCanvas: true,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(this.map);

    this.driverLayers = L.layerGroup().addTo(this.map);
    this._loadCounties();
    this._drawDrivers();
  }

  componentDidUpdate(previousProps) {
    if (previousProps.drivers !== this.props.drivers) {
      this._drawDrivers();
    }
  }

  componentWillUnmount() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  _validDrivers() {
    return (this.props.drivers || []).filter((driver) => {
      const latitude = Number(driver.latitude);
      const longitude = Number(driver.longitude);

      return (
        Number.isFinite(latitude) &&
        Number.isFinite(longitude) &&
        latitude >= IRELAND_BOUNDS[0][0] &&
        latitude <= IRELAND_BOUNDS[1][0] &&
        longitude >= IRELAND_BOUNDS[0][1] &&
        longitude <= IRELAND_BOUNDS[1][1]
      );
    });
  }

  _getCountyName(feature) {
    const properties = feature?.properties || {};

    return (
      properties.NAME_EN ||
      properties.ENGLISH ||
      properties.ENGLISH_NAME ||
      properties.COUNTY ||
      properties.County ||
      properties.county ||
      properties.NAME ||
      properties.name ||
      properties.NAME_2 ||
      "County"
    );
  }

  async _loadCounties() {
    try {
      const response = await fetch(
        this.props.countyGeoJsonUrl || COUNTY_GEOJSON_URL
      );

      if (!response.ok) {
        throw new Error("County boundary request failed.");
      }

      const countyGeoJson = await response.json();

      if (!this.map) {
        return;
      }

      this.countyLayer = L.geoJSON(countyGeoJson, {
        style: {
          color: "#6c757d",
          weight: 1.25,
          opacity: 0.8,
          fillColor: "#f4f6f9",
          fillOpacity: 0.08,
        },
        onEachFeature: (feature, layer) => {
          const countyName = this._getCountyName(feature);

          layer.bindTooltip(countyName, {
            permanent: true,
            direction: "center",
            className: "driver-map-county-label",
          });
        },
      }).addTo(this.map);

      this.countyLayer.bringToBack();
      this.setState({ countyLoading: false, countyError: false });
    } catch (error) {
      console.error("Unable to load Ireland county boundaries:", error);

      if (this.map) {
        this.setState({ countyLoading: false, countyError: true });
      }
    }
  }

  _formatLastSeen(value) {
    if (!value) {
      return "Not provided";
    }

    const date = moment(value);

    return date.isValid()
      ? date.format("DD MMM YYYY - hh:mm A")
      : "Not provided";
  }

  _createPopup(driver) {
    const container = document.createElement("div");
    const name = document.createElement("strong");
    const status = document.createElement("div");
    const county = document.createElement("div");
    const location = document.createElement("div");
    const lastSeen = document.createElement("div");

    name.textContent = driver.name || "Driver";
    status.textContent = `Status: ${
      driver.statusLabel ||
      (driver.isActive ? "Able To Accept Deliveries" : "Offline")
    }`;
    status.style.color = driver.isActive ? "#198754" : "#dc3545";
    status.style.fontWeight = "600";
    county.textContent = `County: ${driver.county || "Not provided"}`;
    location.textContent = `Last location: ${Number(driver.latitude).toFixed(
      6
    )}, ${Number(driver.longitude).toFixed(6)}`;
    lastSeen.textContent = `Last seen: ${this._formatLastSeen(
      driver.lastSeenAt || driver.lastLocationAt
    )}`;

    container.appendChild(name);
    container.appendChild(status);
    container.appendChild(county);
    container.appendChild(location);
    container.appendChild(lastSeen);

    return container;
  }

  _drawDrivers() {
    if (!this.map || !this.driverLayers) {
      return;
    }

    this.driverLayers.clearLayers();

    const drivers = this._validDrivers();
    const bounds = L.latLngBounds([]);

    drivers.forEach((driver) => {
      const point = [Number(driver.latitude), Number(driver.longitude)];
      const colour = driver.isActive ? "#28a745" : "#dc3545";

      L.circleMarker(point, {
        radius: 8,
        color: "#ffffff",
        weight: 2,
        fillColor: colour,
        fillOpacity: 1,
      })
        .bindTooltip(driver.name || "Driver", {
          direction: "top",
          offset: [0, -9],
        })
        .bindPopup(this._createPopup(driver))
        .addTo(this.driverLayers);

      bounds.extend(point);
    });

    if (bounds.isValid()) {
      this.map.fitBounds(bounds, {
        padding: [35, 35],
        maxZoom: 12,
      });
    } else {
      this.map.setView(IRELAND_CENTER, 7);
    }
  }

  render() {
    const drivers = this._validDrivers();
    const activeCount = drivers.filter((driver) => driver.isActive).length;
    const offlineCount = drivers.length - activeCount;
    const { countyLoading, countyError } = this.state;

    return (
      <div className="card card-custom mb-5">
        <div className="card-header">
          <div className="card-title">
            <h3 className="card-label">
              Driver Last Known Locations
              <small className="text-muted ml-2">
                {drivers.length} mapped driver{drivers.length === 1 ? "" : "s"}
              </small>
            </h3>
          </div>

          <div className="card-toolbar driver-map-legend">
            <span className="mr-4">
              <span className="driver-map-dot driver-map-dot-active" />
              Able To Accept Deliveries ({activeCount})
            </span>
            <span>
              <span className="driver-map-dot driver-map-dot-offline" />
              Offline ({offlineCount})
            </span>
          </div>
        </div>

        <div className="card-body p-0 position-relative">
          {this.props.loading && (
            <div className="driver-map-loading">
              <span className="spinner-border text-primary mr-2" />
              Loading driver locations...
            </div>
          )}

          {!this.props.loading && countyLoading && (
            <div className="driver-map-boundary-status">
              Loading county boundaries...
            </div>
          )}

          {countyError && (
            <div className="driver-map-boundary-status text-danger">
              County boundaries could not be loaded.
            </div>
          )}

          <div
            ref={this.mapContainer}
            aria-label="Map of drivers' last known locations in Ireland"
            style={{ height: 560, width: "100%" }}
          />
        </div>
      </div>
    );
  }
}

DriverLastLocationMap.defaultProps = {
  drivers: [],
  loading: false,
  countyGeoJsonUrl: COUNTY_GEOJSON_URL,
};
